/* XHOBIES CAT BALL — scripts propios de las secciones cb- (vanilla) */
(function () {
  "use strict";
  var reducido = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function initBundle() {
    document.querySelectorAll("[data-cb-bundle]").forEach(function (wrap) {
      var form = wrap.closest("form");
      var cantidad = form ? form.querySelector("[data-cb-cantidad]") : null;
      var boton = form ? form.querySelector("[data-xh-boton-comprar]") : null;
      if (!cantidad) return;
      function aplicar() {
        var marcado = wrap.querySelector("input:checked");
        if (!marcado) return;
        cantidad.value = marcado.value;
        if (boton && !boton.disabled && marcado.dataset.textoBoton) {
          boton.dataset.textoDisponible = marcado.dataset.textoBoton;
          boton.textContent = marcado.dataset.textoBoton;
        }
      }
      wrap.querySelectorAll("input").forEach(function (i) { i.addEventListener("change", aplicar); });
      aplicar();
    });
  }

  function initSwatchLabel() {
    document.querySelectorAll("[data-cb-opcion-wrap]").forEach(function (wrap) {
      var etiqueta = wrap.querySelector("[data-cb-opcion-valor]");
      if (!etiqueta) return;
      wrap.querySelectorAll("input").forEach(function (i) {
        i.addEventListener("change", function () { etiqueta.textContent = i.value; });
      });
    });
  }

  function initCountUp() {
    var els = document.querySelectorAll("[data-cb-contar]");
    if (!els.length) return;
    function animar(el) {
      var fin = parseFloat(el.getAttribute("data-cb-contar")) || 0;
      var dec = (String(fin).split(".")[1] || "").length;
      var sufijo = el.getAttribute("data-cb-sufijo") || "";
      if (reducido) { el.textContent = fin.toFixed(dec) + sufijo; return; }
      var t0 = null, dur = 1600;
      function paso(t) {
        if (!t0) t0 = t;
        var p = Math.min((t - t0) / dur, 1);
        var e = 1 - Math.pow(1 - p, 3);
        el.textContent = (fin * e).toFixed(dec) + sufijo;
        if (p < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    }
    if (!("IntersectionObserver" in window)) { els.forEach(animar); return; }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { animar(en.target); obs.unobserve(en.target); }
      });
    }, { threshold: 0.5 });
    els.forEach(function (el) { obs.observe(el); });
  }

  function initStickyBar() {
    var barra = document.querySelector("[data-cb-sticky]");
    var objetivo = document.querySelector("[data-cb-compra]");
    if (!barra || !objetivo || !("IntersectionObserver" in window)) return;
    var visto = false;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { visto = true; barra.classList.remove("cb-visible"); }
        else if (visto || en.boundingClientRect.top < 0) { barra.classList.add("cb-visible"); }
      });
    }, { threshold: 0 });
    obs.observe(objetivo);
    var btn = barra.querySelector("[data-cb-sticky-ir]");
    if (btn) btn.addEventListener("click", function (e) {
      e.preventDefault();
      objetivo.scrollIntoView({ behavior: reducido ? "auto" : "smooth", block: "start" });
    });
  }

  function initParallax() {
    if (reducido) return;
    var imgs = document.querySelectorAll("[data-cb-parallax]");
    if (!imgs.length) return;
    var ticking = false;
    function update() {
      imgs.forEach(function (img) {
        var r = img.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        var f = parseFloat(img.getAttribute("data-cb-parallax")) || 0;
        img.style.translate = "0 " + (r.top * -f).toFixed(1) + "px";
      });
      ticking = false;
    }
    window.addEventListener("scroll", function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initBundle();
    initSwatchLabel();
    initCountUp();
    initStickyBar();
    initParallax();
  });
})();
